export const defaultLocale: Locale = 'en_US'

export type Locale = keyof typeof locales

export const locales = {
  en_US: { locale: 'en_US', lang: 'en', title: 'English' },
  en_GB: { locale: 'en_GB', lang: 'en', title: 'English (GB)' },
  de_DE: { locale: 'de_DE', lang: 'de', title: 'German' },
  da_DK: { locale: 'da_DK', lang: 'da', title: 'Danish' },
  ru_RU: { locale: 'ru_RU', lang: 'ru', title: 'Russian' },
  ar_AR: { locale: 'ar_AR', lang: 'ar', title: 'Arabic', rtl: true },
  it_IT: { locale: 'it_IT', lang: 'it', title: 'Italian' },
  fr_FR: { locale: 'fr_FR', lang: 'fr', title: 'French' },
  fr_CA: { locale: 'fr_CA', lang: 'fr', title: 'French (Canadian)' },
  es_ES: { locale: 'es_ES', lang: 'es', title: 'Spanish' },
  es_LA: { locale: 'es_LA', lang: 'es', title: 'Spanish (Latin America)' },
  pt_PT: { locale: 'pt_PT', lang: 'pt', title: 'Portuguese' },
  pt_BR: { locale: 'pt_BR', lang: 'pt', title: 'Portuguese (Brazilian)' },
  ja_JP: { locale: 'ja_JP', lang: 'ja', title: 'Japanese' },
  ko_KR: { locale: 'ko_KR', lang: 'ko', title: 'Korean' },
  nl_NL: { locale: 'nl_NL', lang: 'nl', title: 'Dutch' },
  nb_NO: { locale: 'nb_NO', lang: 'nb', title: 'Norwegian (bokmal)' },
  zh_CN: { locale: 'zh_CN', lang: 'zh', title: 'Simplified Chinese (China)' },
  zh_TW: {
    locale: 'zh_TW',
    lang: 'zh',
    title: 'Traditional Chinese (Taiwan)',
  },
  zh_HK: {
    locale: 'zh_HK',
    lang: 'zh',
    title: 'Traditional Chinese (Hong Kong)',
  },
  id_ID: { locale: 'id_ID', lang: 'id', title: 'Indonesian' },
  th_TH: { locale: 'th_TH', lang: 'th', title: 'Thai' },
  vi_VN: { locale: 'vi_VN', lang: 'vi', title: 'Vietnamese' },
  pl_PL: { locale: 'pl_PL', lang: 'pl', title: 'Polish' },
  ro_RO: { locale: 'ro_RO', lang: 'ro', title: 'Romanian' },
  cs_CZ: { locale: 'cs_CZ', lang: 'cs', title: 'Czech' },
  he_IL: { locale: 'he_IL', lang: 'he', title: 'Hebrew', rtl: true },
  el_GR: { locale: 'el_GR', lang: 'el', title: 'Greek' },
  tr_TR: { locale: 'tr_TR', lang: 'tr', title: 'Turkish' },
  hu_HU: { locale: 'hu_HU', lang: 'hu', title: 'Hungarian' },
  sv_SE: { locale: 'sv_SE', lang: 'sv', title: 'Swedish' },
} as const

export const defaultLocales: Record<string, Locale> = {
  en: 'en_US',
  de: 'de_DE',
  da: 'da_DK',
  ru: 'ru_RU',
  ar: 'ar_AR',
  it: 'it_IT',
  fr: 'fr_FR',
  es: 'es_ES',
  pt: 'pt_PT',
  ja: 'ja_JP',
  ko: 'ko_KR',
  nl: 'nl_NL',
  nb: 'nb_NO',
  zh: 'zh_CN',
  id: 'id_ID',
  th: 'th_TH',
  vi: 'vi_VN',
  pl: 'pl_PL',
  ro: 'ro_RO',
  cs: 'cs_CZ',
  he: 'he_IL',
  el: 'el_GR',
  tr: 'tr_TR',
  hu: 'hu_HU',
  sv: 'sv_SE',
}

export const getChiliLocale = (baseLocale: string) => {
  let locale: Locale | undefined
  if (baseLocale.length === 2) {
    locale = defaultLocales[baseLocale]
  } else {
    const replacedLocale = baseLocale.replace('-', '_')
    locale = replacedLocale in locales ? (replacedLocale as Locale) : undefined
  }
  return locale
}

export const getLocale = (): Locale => {
  const baseLocale = navigator.language // either "en" or "en_US" format
  return getChiliLocale(baseLocale) ?? defaultLocale
}
